import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const List = styled.ul`
  margin-left: ${Spacing.S8};
  list-style: disc;
`

export const SubList = styled.ul`
  margin-left: ${Spacing.S8};
  list-style: circle;
`

export const ListItem = styled.li`
  margin-left: ${Spacing.S16};
`
